import { createFileRoute } from "@tanstack/react-router";
import { SearchPage } from "../features/search/SearchPage";

export const Route = createFileRoute("/w/$ws/search")({
  validateSearch: (search: Record<string, unknown>): { q?: string } =>
    typeof search.q === "string" && search.q ? { q: search.q } : {},
  component: () => <SearchPage q={Route.useSearch().q ?? ""} />,
});
